var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeAnnoucementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(23748 23508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm0-6a4,4,0,1,0-4-4A4,4,0,0,0,12,16Zm0,2a6,6,0,1,1,6-6A6,6,0,0,1,12,18Zm0-4a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z",
    transform: "translate(-23750 -23510)",
    fill: "#575757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeAnnoucementIcon);
export default __webpack_public_path__ + "static/media/employee_annoucement_icon.0c3441a969c08913721b1b1a7303e750.svg";
export { ForwardRef as ReactComponent };